import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import * as moment from 'moment';

import calendarReducer from './reducers/calendar.reducer';
import { ICalendarState, ICalendarSettings, defaultCalendarSettings } from '../classes/calendar';
import { ICalendarAppText } from '../custom/classes/calendar-text';
import { IEvent } from '../custom/classes/event';
import { eventsUpdated, updateUpNext } from './actions/calendar.actions';

import calendarSettingsReducer from './reducers/calendar-settings.reducer';
import { getEventsFromApi, getText, getUpNext } from './actions/calendar-api.actions';
import calendarTextReducer from './reducers/calendar-text.reducer';
import { IPromoCodeState } from '../classes/promo-code';
import promoCodeReducer from './reducers/promo-code.reducer';
import { receiveText } from './actions/calendar-text.actions';
import { ILazyLoadState } from '../classes/lazy-load';
import lazyLoadReducer from './reducers/lazy-load.reducer';
import { GetFilterFromQuery, AddFilterToQuery } from '../helpers/filter-by-query';
declare const lastDate: string;
declare const pageData: string;
const lastDateMoment = moment(lastDate);

export interface ICalendarAppState {
    calendar: ICalendarState<IEvent>;
    calendarSettings: ICalendarSettings;
    calendarText: ICalendarAppText;
    promoCode: IPromoCodeState;
    lazyLoad: ILazyLoadState;
}

const appReducer = combineReducers({
    calendar: calendarReducer,
    calendarSettings: calendarSettingsReducer,
    calendarText: calendarTextReducer,
    promoCode: promoCodeReducer,
    lazyLoad: lazyLoadReducer
});

// Calculate the months that are valid on the calendar.
let monthsOnCalendar: moment.Moment[] = [];

for (let i = moment().clone().startOf("month"); i.isSameOrBefore(lastDateMoment.endOf("month")); i.add(1, "month")) {
    monthsOnCalendar.push(i.clone());
}

let calendarSettings = {
    ...defaultCalendarSettings,
    monthsOnCalendar: monthsOnCalendar
};

const appStore = createStore(appReducer, {
    calendarSettings: calendarSettings
}, applyMiddleware(thunk));


if (window.location.hash.length > 1) {
    GetFilterFromQuery(window.location.hash, appStore);
}

// redux-thunk messes with redux typings.
appStore.dispatch(getEventsFromApi() as any);
appStore.dispatch(getUpNext() as any);


appStore.dispatch(receiveText(JSON.parse(pageData)) as any);

let prevState = appStore.getState();

appStore.subscribe(() => {
    const currState = appStore.getState();

    const apiUpdate = !prevState.calendar.startDate.isSame(currState.calendar.startDate) || !prevState.calendar.endDate.isSame(currState.calendar.endDate);

    AddFilterToQuery(currState.calendar);

    // If the event references are completely different, re-calculate them.
    if (apiUpdate || (currState.calendar.updating && prevState.calendar.events !== currState.calendar.events)) {
        prevState = appStore.getState();

        appStore.dispatch(getEventsFromApi() as any);
        appStore.dispatch(getUpNext() as any);
    }
});

export { appStore };